<template>
  <a-modal
    title="合同预览"
    :width="1180"
    :visible="visible"
    :maskClosable="true"
    :closable="true"
    :confirmLoading="loading"
    :footer="null"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form>
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              合同信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <span v-if="this.data">{{ this.data['number'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <span v-if="this.data">{{ this.data['contract_number'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <span v-if="this.data">{{ this.data['name'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="客户" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data && this.clientList.length > 0">{{ this.clientList.filter(item => this.data['client_ids'].includes(item.client_id)).map(item => item.client).join(',') }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="担保方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.$Dictionaries.guarantee_method[this.data['guarantee_method']] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="存放地" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.data['storage_location'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="抵押物" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.data['collateral'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="质押物" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.data['pledged_goods'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="抵/质押货物价值" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.data['collateral_pledged_goods_value'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="登记方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">{{ this.data['registration_method'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="担保期限" :label-col="labelCol" :wrapper-col="wrapperCol">
              <span v-if="this.data">
                {{ this.data['guarantee_period_start_date'] === '1970-01-01' ? '' : this.data['guarantee_period_start_date'] + '~' }}
                {{ this.data['guarantee_period_end_date']  === '1970-01-01' ? '' : this.data['guarantee_period_end_date']}}
              </span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同附件" :label-col="buttonCol.labelCol" :wrapper-col="buttonCol.wrapperCol">
              <a-table
                bordered
                :data-source="attachmentList"
                :columns="attachmentColumns"
                v-if="this.attachmentList.length > 0"
                :pagination="false"
                key="key">
                <span slot="action" slot-scope="text, record">
                  <template>
                    <a :href="record.url" target="_blank">预览</a>
                  </template>
                </span>
              </a-table>
              <span v-else>无</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { guarantee_contract_attachment_list, guarantee_contract_list } from '@/api/trade_guarantee_contract'
import { project_client_list } from '@/api/trade_project_client'
export default {
  name: 'WatchViewForm',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        labelCol: {
          xs: { span: 3 },
          sm: { span: 3 }
        },
        wrapperCol: {
          xs: { span: 21 },
          sm: { span: 21 }
        }
      },
      data: undefined,
      loading: false,
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 300,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      attachmentList: [],
      clientList: []
    }
  },
  mounted () {
    this.loadContract()
    this.loadContractAttachment()
  },
  methods: {
    loadContract () {
      this.loading = true
      guarantee_contract_list({ id: this.model['id'] }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.handleClientSearch()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClientSearch () {
      project_client_list({ project_id: this.data.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = result
      })
    },
    loadContractAttachment () {
      guarantee_contract_attachment_list({ contract_id: this.model['id'] }).then(res => {
        if (res.code === 1000 && res.data.entries) {
          this.attachmentList = res.data.entries
        }
      })
    }
  }
}
</script>
